import React from 'react';
import { getLabel } from '../../utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare , faTwitter } from '@fortawesome/free-brands-svg-icons';

import SharePageHolder from './SharePageStyles';

const SharePage = () => {

	const onFaClickHandler = (curLocation) => {
		window.open("https://www.facebook.com/sharer/sharer.php?u="+curLocation, "_blank");
	}

	const onTwClickHandler = (curLocation) => {
		window.open("https://twitter.com/share?url="+curLocation, "_blank");
	}

	return (
		<SharePageHolder>
			<div className="share-container" itemScope itemType="https://schema.org/ShareAction">
				<span tabIndex="0">{getLabel("SHARE")}</span>
				<button className="shBtns faBtn" onClick={(e)=>onFaClickHandler(window.location.href)} itemProp="potentialAction"><FontAwesomeIcon icon={faFacebookSquare}/> Facebook</button>
				<button className="shBtns twBtn" onClick={(e)=>onTwClickHandler(window.location)} itemProp="potentialAction"><FontAwesomeIcon icon={faTwitter}/> Twitter</button>
			</div>
		</SharePageHolder>
	)
}

export default SharePage;